import * as Sentry from '@sentry/react'
import { http, httpWithoutAuth } from 'src/utils/http.util'
import type { TLoginCredentials, TLoginResponse } from '../types/session'
import { EAuthMethod, type TLoginMethodResponse } from 'src/types/login-method'
import type { TRequestPin, TResetPassword, TRegister } from 'src/pages/auth/_components/auth.type'

export class AuthService {
  static async login(credentials: TLoginCredentials): Promise<TLoginResponse> {
    const response = await httpWithoutAuth.post<TLoginResponse>('/auth/login', credentials)
    return response.data
  }

  /** Falls back to PASSWORD on any failure so that a local user is never blocked from logging in. */
  static async getLoginMethod(email: string): Promise<EAuthMethod> {
    try {
      const response = await httpWithoutAuth.post<TLoginMethodResponse>('/auth/login/method', { email })
      return response.data.method
    } catch (error) {
      Sentry.captureException(error, { tags: { feature: 'lifen-connect-login-method' } })
      return EAuthMethod.PASSWORD
    }
  }

  static async logout(): Promise<void> {
    // Clear session from localStorage
    localStorage.removeItem('curecall-session')

    // Optional: call backend logout endpoint if exists
    // await http.post('/auth/logout/')
  }
}

export const AuthServices = {
  requestPin: async (form: TRequestPin): Promise<void> => {
    return http.post(`/auth/forgot-password/request-pin`, form).then((res) => res.data)
  },

  resetPassword: async (form: TResetPassword): Promise<TRegister> => {
    return http.post('auth/forgot-password/reset-password', form).then((res) => res.data)
  },
}
